import PostOrganici from "@/pages/PostOrganici";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AppLayout } from "@/components/layout/AppLayout";
import Onboarding from "@/pages/Onboarding";
import Home from "@/pages/Home";
import Demo from "@/pages/Demo";
import Piani from "@/pages/Piani";
import Registrati from "@/pages/Registrati";
import Accedi from "@/pages/Accedi";
import PasswordDimenticata from "@/pages/PasswordDimenticata";
import VerificaEmail from "@/pages/VerificaEmail";
import { AuthProvider, ProtectedRoute } from "@/lib/auth";
import Dashboard from "@/pages/Dashboard";
import NadiaChat from "@/pages/NadiaChat";
import Obiettivo from "@/pages/Obiettivo";
import BusinessBrain from "@/pages/BusinessBrain";
import PianoMarketing from "@/pages/PianoMarketing";
import Campagne from "@/pages/Campagne";
import Risultati from "@/pages/Risultati";
import AzioniNadia from "@/pages/AzioniNadia";
import AttivitaAgente from "@/pages/AttivitaAgente";
import Automazioni from "@/pages/Automazioni";
import LandingBuilder from "@/pages/LandingBuilder";
import Retargeting from "@/pages/Retargeting";
import Leads from "@/pages/Leads";
import VideoStudio from "@/pages/VideoStudio";
import PublicLanding from "@/pages/PublicLanding";
import Impostazioni from "@/pages/Impostazioni";
import DatiFatturazione from "@/pages/DatiFatturazione";
import PagamentoEsito from "@/pages/PagamentoEsito";
import CanaliAds from "@/pages/CanaliAds";
import Amministrazione from "@/pages/Amministrazione";
import LegalPage from "@/pages/LegalPage";
import LegalFooter from "@/components/legal/LegalFooter";
import { ProFeatureGate } from "@/components/nadia/PlanFeatures";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#131C2E",
            border: "1px solid rgba(255,255,255,0.08)",
            color: "#F8FAFC",
          },
        }}
      />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/piani" element={<Piani />} />
        <Route path="/privacy" element={<LegalPage path="/privacy" />} />
        <Route path="/cookie" element={<LegalPage path="/cookie" />} />
        <Route path="/termini" element={<LegalPage path="/termini" />} />
        <Route path="/accordo-dati" element={<LegalPage path="/accordo-dati" />} />
        <Route path="/registrati" element={<Registrati />} />
        <Route path="/accedi" element={<Accedi />} />
        <Route path="/password-dimenticata" element={<PasswordDimenticata />} />
        <Route path="/reimposta-password" element={<PasswordDimenticata />} />
        <Route path="/verifica-email" element={<VerificaEmail />} />
        <Route path="/dati-fatturazione" element={<ProtectedRoute><DatiFatturazione /></ProtectedRoute>} />
        <Route path="/pagamento/esito" element={<ProtectedRoute><PagamentoEsito /></ProtectedRoute>} />
        <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
        <Route path="/l/:slug" element={<PublicLanding />} />
        <Route path="/app" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
          <Route index element={<Navigate to="/app/nadia" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="nadia" element={<NadiaChat />} />
          <Route path="obiettivo" element={<Obiettivo />} />
          <Route path="business-brain" element={<BusinessBrain />} />
          <Route path="piano" element={<PianoMarketing />} />
          <Route path="campagne" element={<Campagne />} />
          <Route path="ads" element={<CanaliAds />} />
          <Route path="post-organici" element={<PostOrganici />} />
            <Route path="uscite-social" element={<PostOrganici />} />
          <Route path="risultati" element={<Risultati />} />
          <Route path="azioni" element={<AzioniNadia />} />
          <Route path="attivita" element={<AttivitaAgente />} />
          <Route path="automazioni" element={<Automazioni />} />
          <Route path="landing" element={<ProFeatureGate feature="landing_ai"><LandingBuilder /></ProFeatureGate>} />
          <Route path="retargeting" element={<ProFeatureGate feature="retargeting"><Retargeting /></ProFeatureGate>} />
          <Route path="lead" element={<Leads />} />
          <Route path="video" element={<VideoStudio />} />
          <Route path="impostazioni" element={<Impostazioni />} />
          <Route path="amministrazione" element={<Amministrazione />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <LegalFooter />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
